module.exports = __webpack_public_path__ + "img/mesa_hl29.94aeed8b.png";